<div *ngIf="data">

    <div class="filter-actions">
        <button class="btn-outlined" type="button" (click)="clearFilters()">
            <fa-icon [icon]="faFilterCircleXmark"></fa-icon>
            Clear Filters
        </button>
    </div>
    <table class="ts-table">
        <thead>
            <tr>
                <th *ngIf="isCheckboxAvailable()" [ngStyle]="{'display': isAccountFullAllocated(data.orders) ? 'none' : ''}">
                    <input type="checkbox" class="ts-checkbox" [(ngModel)]="data.parentChecked"
                        *ngIf="!isAccountFullAllocated(data.orders)"
                        [indeterminate]="data.partiallyChecked"
                        (change)="parentCheckboxChanged(data)">
                </th>
                <ng-container *ngFor="let column of getNonActionDisplayedColumns()">
                    <th *ngIf="isNonActionColumn(column) && column.key !== getQuantityAllocatedColumn()?.key"
                        class="header-vertical-border"
                        [ngClass]="{'text-right-numeric': column.type === TableColumnType.number || column.type === TableColumnType.currency || column.key === 'accountId' || column.key === 'orderId' || column.key === 'quantityAllocated' || column.key === 'quantityToAllocate'}">
                        <div class="header-content">
                            <div [ngClass]="{'header-title-left': column.type !== TableColumnType.number && column.type !== TableColumnType.currency && column.key !== 'accountId' && column.key !== 'orderId' && column.key !== 'quantityAllocated' && column.key !== 'quantityToAllocate'}">
                                {{column.displayName}}
                            </div>
                            <div *ngIf="column.isFilterEnabled" [ngClass]="{'header-title-left': column.type !== TableColumnType.number && column.type !== TableColumnType.currency && column.key !== 'accountId' && column.key !== 'orderId' && column.key !== 'quantityAllocated' && column.key !== 'quantityToAllocate'}">
                                <input #filter id="{{column.key}}-filter" class="filter"
                                    [ngClass]="{'text-right-numeric': column.type === TableColumnType.number || column.type === TableColumnType.currency || column.key === 'accountId' || column.key === 'orderId' || column.key === 'quantityAllocated' || column.key === 'quantityToAllocate'}"
                                    [type]="column.type === TableColumnType.number ? 'number' : 'text'"
                                    [min]="column.type === TableColumnType.number ? 0 : null"
                                    (input)="applyFilters()" size="8" placeholder="Filter">
                            </div>
                        </div>
                    </th>
                </ng-container>
                <th *ngIf="isQuantityAllocatedAvailable()" class="text-right-numeric header-vertical-border">
                    <span>{{getQuantityAllocatedColumn().displayName}}</span>
                </th>
                <th *ngIf="isQuantityToAllocateAvailable()" class="text-right-numeric header-vertical-border">
                    <span>{{getQuantityToAllocateColumn().displayName}}</span>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let order of filteredData">
                <td *ngIf="isCheckboxAvailable()" [ngStyle]="{'display': isAccountFullAllocated(data.orders) ? 'none' : ''}">
                    <input type="checkbox" class="ts-checkbox" [(ngModel)]="order.checked"
                        *ngIf="!order?.quantityAllocated"
                        (change)="checkboxChanged(order, $event)">
                </td>
                <ng-container *ngFor="let column of getNonActionDisplayedColumns(); let i = index">
                    <td *ngIf="isNonActionColumn(column) && column.key !== getQuantityAllocatedColumn()?.key"
                        [ngClass]="{'text-right-numeric': column.type === TableColumnType.number || column.type === TableColumnType.currency || column.key === 'accountId' || column.key === 'orderId' || column.key === 'quantityAllocated' || column.key === 'quantityToAllocate'}"
                        [ngStyle]="{'color': (order?.quantityAllocated !== 0 && i === 0) ? 'green': '', 'font-weight': (order?.quantityAllocated !== 0 && i === 0) ? 'bold': ''}">
                        <div [ngSwitch]="column.type">
                            <div *ngSwitchCase="TableColumnType.text">
                                {{order[column.key]}}
                            </div>
                            <div *ngSwitchCase="TableColumnType.number">
                                {{order[column.key] | number: '1.0-0'}}
                            </div>
                            <div *ngSwitchCase="TableColumnType.currency">
                                {{order[column.key] | currency:'USD':'symbol':'1.2-2'}}
                            </div>
                        </div>
                    </td>
                </ng-container>
                <td *ngIf="isQuantityAllocatedAvailable()" class="text-right-numeric"
                    [ngStyle]="{'color': (order?.quantityAllocated !== 0) ? 'green': '', 'font-weight': (order?.quantityAllocated !== 0) ? 'bold': ''}">
                    {{ order.quantityAllocated }}
                </td>
                <td *ngIf="isQuantityToAllocateAvailable()" class="text-right-numeric">
                    <b *ngIf="isOrderFullAllocated(order)" class="none-text">None </b>
                    <input type="number" *ngIf="!isOrderFullAllocated(order)" class="quantity-input"
                        [(ngModel)]="order.quantityToAllocate"
                        (ngModelChange)="quantityToAllocateChanged(order, $event)">
                </td>
            </tr>
        </tbody>
    </table>
    <app-empty-state *ngIf="filteredData.length === 0 && allData.length > 0"
        [icon]="faFilterCircleXmark"
        [compact]="true"
        headline="No orders match your filters"
        hint="Clear the column filters above to see all orders for this account."></app-empty-state>
    <app-empty-state *ngIf="allData.length === 0"
        [icon]="faReceipt"
        [compact]="true"
        headline="No orders to allocate"
        hint="This account has no orders available for allocation."></app-empty-state>
</div>
